import { User } from "../models/user.model";
import { createUseApi } from "./useApi";
const config = useRuntimeConfig();
export const authentication = {
  useCurrentUser: createUseApi<void, User>({
    method: "GET",
    url: `${config.public.url}/auth`,
    requireAuthentication: true,
    attachXLocaleHeader: false,
  }),
  useLogin: createUseApi<
    { email: string; password: string },
    {
      accessToken: string;
    }
  >({
    method: "POST",
    url: `${config.public.url}/auth/login`,
    dataBuilder: (input) => {
      return input;
    },
    requireAuthentication: false,
    attachXLocaleHeader: false,
  }),
  useRegister: createUseApi<{ email: string; password: string }, User>({
    method: "POST",
    url: `${config.public.url}/user`,
    dataBuilder: (input) => input,
    requireAuthentication: false,
    attachXLocaleHeader: false,
  }),
  useForgotPassword: createUseApi<{ email: string }, void>({
    method: "POST",
    url: `${config.public.url}/password-change/restore`,
    dataBuilder(input) {
      return input;
    },
    requireAuthentication: false,
    attachXLocaleHeader: false,
  }),
  useForgotPasswordRestore: createUseApi<
    { secret: string; password: string },
    void
  >({
    method: "PATCH",
    url: `${config.public.url}/password-change/restore`,
    dataBuilder(input) {
      return input;
    },
    requireAuthentication: false,
    attachXLocaleHeader: false,
  }),
};
